var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active-plan"},[(_vm.isBusinessSubscription)?_c('BusinessPlan',{attrs:{"plan":_vm.subscription}}):[_c('PlanDetails',_vm._b({},'PlanDetails',{
        planName: _vm.plan && _vm.plan.name ? _vm.plan.name : 'Legacy Plan',
        planCode: _vm.subscription.plan_code,
        accountCredit: _vm.accountCredit,
        renewal: _vm.renewal,
        isBusinessSubscription: _vm.isBusinessSubscription,
        isPlanActive: _vm.isPlanActive,
        isPlanFailed: _vm.isPlanFailed,
        isPlanInCancelledState: _vm.isPlanInCancelledState,
        isPlanPending: _vm.isPlanPending,
        planHasProvider: _vm.planHasProvider,
        planExpiryDate: _vm.planExpiryDate,
        daysRemainingForSub: _vm.daysRemainingForSub,
      },false)),(_vm.canViewPlanActions)?_c('PlanActions',_vm._b({on:{"cancel-renewal-clicked":_vm.handleCancelRenewalClick,"reactivate-renewal-clicked":_vm.handleReactivateRenewalClick,"upgrade-plan-clicked":_vm.handleUpgradeClick,"update-payment-method":function($event){return _vm.$emit('is-managing-payment')}}},'PlanActions',{
        isLoading: _vm.isLoading,
        plan: _vm.subscription,
        isPlanActive: _vm.isPlanActive,
        isPlanFailed: _vm.isPlanFailed,
        isPlanInCancelledState: _vm.isPlanInCancelledState,
        planExpiryDate: _vm.planExpiryDate,
      },false)):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }